import { toast } from 'react-toastify';
import {
  COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_BEGIN,
  COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_SUCCESS,
  COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_FAILURE,
  COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createRowLevelSecurityFilterInCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_BEGIN,
    });
    const { projectId, version, collectionUuid, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/security/row-level-security-filter/${collectionUuid}/collection`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          toast.success('Row Level Security Filter Created Successfully !');
          dispatch({
            type: COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created collection row level security filter');
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create collection row level security filter');
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateRowLevelSecurityFilterInCollectionError() {
  return {
    type: COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_BEGIN:
      return {
        ...state,
        createRowLevelSecurityFilterInCollectionPending: true,
        createRowLevelSecurityFilterInCollectionError: null,
      };

    case COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        createRowLevelSecurityFilterInCollectionPending: false,
        createRowLevelSecurityFilterInCollectionError: null,
        selectedCollection: action.data,
        projectCollections,
      };

    case COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_FAILURE:
      return {
        ...state,
        createRowLevelSecurityFilterInCollectionPending: false,
        createRowLevelSecurityFilterInCollectionError: action.data.error,
      };

    case COLLECTIONS_CREATE_ROW_LEVEL_SECURITY_FILTER_IN_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createRowLevelSecurityFilterInCollectionError: null,
      };

    default:
      return state;
  }
}
